/**
 * Trims any fragments from the provided property.
 * @param owner Object containing the property to trim.
 * @param property Name of the property to trim.
 */
export function trimFragment(owner: any, property: string): void {

    // If the property has a string value that appears to contain a URL, attempt trimming any fragments
    if (typeof owner[property] === "string" && /http(s)?:\/\/.+/.test(owner[property])) {
        owner[property] = owner[property].replace(/#[^:\s]*/g, "#scrubbed");
    }
}

/**
 * Trims any fragments from the provided object's string properties.
 * @param object Object containing the properties to trim.
 */
export function trimFragments(object: any): void {

    // Only trim fragments from objects
    if (typeof object !== "object") {
        return;
    }

    for (var propertyName in object) {
        var property = object[propertyName];
        if (typeof property === "object") {
            trimFragments(property);
        } else {
            trimFragment(object, propertyName);
        }
    }
}
